import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  LinearProgress,
} from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import TokenPool from "../components/SearchTokenPools/TokenPool";
import Table from "../components/Misc/Table";
import Doughnut from "../assets/Doughnut.png";
import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";
import { getClaimablebyProjectId, getCampaignFollowers } from "../redux";
import { useDispatch, useSelector } from "react-redux";

// import TokenPool from "../components/SearchTokenPools/TokenPool";
// import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";

const useStyles = makeStyles((theme) => ({
  StepContainer: {
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    padding: "1.5rem",
    height: "13rem",

    flexWrap: "wrap",
  },
  pieBox: {
    marginTop: "4rem",
    padding: "0px 1rem",
    display: "flex",
    justifyContent: "space-between",
  },
  list: {
    alignItems: "center",
    margin: "3rem 1rem 0px 1rem",
  },
  BigCard: {
    background: "#FFFFFF",
    marginTop: "2rem",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",

    padding: "1.5rem",
    width: "45%",
    minWidth: "300px",
    // height: "30rem",
  },
  Card3: {
    width: "100%",
    backgroundColor: "white",
    padding: "2.5rem",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",

    height: "30rem",
    marginTop: "3rem",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3rem",
    marginBottom: "1rem",
    marginLeft: "1rem",
  },

  container: {
    padding: "1rem",
    // maxWidth: "1100px",
  },
  percentage: {
    fontSize: "3.5rem",
    fontWeight: "700",
    margin: "1rem 1rem 0rem 0rem",
  },
  grid: {
    display: "flex",
    justifyContent: "space-between",
  },
  card: {
    margin: "1rem",
    width: "27%",
  },
  bold: {
    fontWeight: "500",
    fontSize: "1.3rem",
  },
  barColor: {
    backgroundColor: "#F630A9",
  },
  dot: {
    backgroundColor: ({ color }) => color,
    height: "6px",
    width: "6px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },
  barRoot: {
    height: "1.2rem",
    borderRadius: "8px",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    padding: "0.5rem 0rem",
  },
}));
const Dot = (color) => {
  const classes = useStyles(color);

  return <Box className={classes.dot}></Box>;
};

const SearchTokenPools = () => {
  const dispatch = useDispatch();

  const isUser = useSelector((state) => state.ui.isUser);
  const [withdrawData, setWithdrawData] = useState(false);
  const [depositData, setDepositData] = useState(false);
  const [camFollowers, setCamFollowers] = useState(0);

  useEffect(() => {
    if (isUser?.project?._id) {
      const func = async () => {
        const withdrawTableData = await getClaimablebyProjectId(
          isUser?.project?._id
        );
        setWithdrawData(withdrawTableData);
        console.log({ withdrawTableData });

        const depositTabledata = isUser?.project;
        setDepositData(depositTabledata);
        console.log({ depositTabledata });

        // FOR FOLLOWERS
        const followers = await getCampaignFollowers(
          isUser?.project?.campaigns[0]?._id
        );
        // if (followers > 10000) {
        //   setCamFollowers(camFollowers / 1000);
        // } else {
        setCamFollowers(followers);
        // }
        console.log({ followers });
      };

      func();
    }
  }, [isUser]);

  const MyTypography = ({ children }) => {
    return (
      <Typography style={{ fontSize: "1rem", textAlign: "center" }}>
        {" "}
        {children}
      </Typography>
    );
  };

  function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center" style={{ margin: "2rem 2rem" }}>
        <Box minWidth={40}>
          <MyTypography>5 Stars</MyTypography>
        </Box>
        <Box width="100%" mr={1} ml={1}>
          <LinearProgress
            variant="determinate"
            value={props.value}
            style={{ backgroundColor: "rgba(246, 48, 169, 0.15)" }}
            classes={{ bar: classes.barColor, root: classes.barRoot }}
          />
        </Box>
        <Box minWidth={35}>
          <MyTypography>{`${Math.round(props.value)}%`}</MyTypography>
        </Box>
      </Box>
    );
  }

  const classes = useStyles();
  //   const [showModal, setShowModal] = useState(false);
  const value = 4;
  const Theading = ["Vesting Release", "Deposit token ", "Deposit Status", " "];
  const Theading2 = ["Kol Name", "Deposit token ", "Deposit Status", " "];

  return (
    <>
      <Box className={classes.container}>
        <Typography className={classes.pageHeading}>Progress Hub</Typography>

        <Box className={classes.grid}>
          <Grid className={classes.card}>
            <Box className={classes.StepContainer}>
              <Typography className={classes.bold}>Pool Filled</Typography>
              <Typography className={classes.percentage}>
                {(
                  (isUser?.project?.campaigns[0]?.investmentFilled /
                    isUser?.project?.campaigns[0]?.budget) *
                  100
                ).toFixed(2)}
                %
              </Typography>
            </Box>
          </Grid>
          <Grid className={classes.card}>
            <Box className={classes.StepContainer}>
              <Typography className={classes.bold}>
                Campaign Progress
              </Typography>
              <Typography className={classes.percentage}>83.5%</Typography>
            </Box>
          </Grid>
          <Grid className={classes.card}>
            <Box className={classes.StepContainer}>
              <Typography className={classes.bold}>
                Followers Reached
              </Typography>
              <Typography className={classes.percentage}>
                {camFollowers > 10000
                  ? `${camFollowers / 1000}k`
                  : camFollowers}
              </Typography>
            </Box>
          </Grid>
        </Box>

        <Box className={classes.grid}>
          <Box className={classes.BigCard}>
            <Typography className={classes.bold}>KOLs Rating</Typography>

            <Box
              style={{ textAlign: "center" }}
              component="fieldset"
              mb={3}
              borderColor="transparent"
            >
              <Typography className={classes.bold}>Average Ranking </Typography>
              <Rating size="large" name="read-only" value={value} readOnly />
            </Box>
            <LinearProgressWithLabel value={80} />
            <LinearProgressWithLabel value={30} />

            <LinearProgressWithLabel value={40} />

            <LinearProgressWithLabel value={90} />

            <LinearProgressWithLabel value={50} />
          </Box>

          <Box className={classes.BigCard}>
            <Typography className={classes.bold}>KOL's Geography</Typography>
            <Box className={classes.pieBox}>
              <Box>
                <img width="200rem" src={Doughnut} />
              </Box>
              <Box className={classes.list}>
                <Box className={classes.flex}>
                  <Dot color="#f630a9" />
                  <Typography>United States</Typography>
                </Box>

                <Box className={classes.flex}>
                  <Dot color="#1e304a" />
                  <Typography>Canade</Typography>
                </Box>
                <Box className={classes.flex}>
                  <Dot color="#3D4C62" />
                  <Typography>Germany</Typography>
                </Box>
                <Box className={classes.flex}>
                  <Dot color="#345D9B" />
                  <Typography>Australia</Typography>
                </Box>
                <Box className={classes.flex}>
                  <Dot color="#5388d8" />
                  <Typography>China</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Table
          depositData={depositData}
          Theading={Theading}
          title="Deposit Project Tokens to Pool"
        />
        <Table
          withdrawData={withdrawData}
          Theading={Theading2}
          title="Withdraw Funds (USDT) from Pool"
        />
      </Box>

      {/* <ProjectDetailsModal showModal={showModal} setShowModal={setShowModal} /> */}
    </>
  );
};

export default SearchTokenPools;
